(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 37948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(23629);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Slug": function() { return /* binding */ Slug; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _byko_lib_api_dato_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42039);
/* harmony import */ var _byko_scene_byko_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65776);
/* harmony import */ var _byko_scene_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4651);





const Slug = (param)=>{
    let { slug , notFound , internalError , data: initialData  } = param;
    const { data  } = (0,_byko_lib_api_dato_client__WEBPACK_IMPORTED_MODULE_1__/* .usePageBySlug */ .Rb)({
        slug,
        initialData
    });
    if (!slug || notFound) {
        // TODO: Add page not found
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_error__WEBPACK_IMPORTED_MODULE_3__/* .ErrorScene */ ._, {
            code: 404
        });
    }
    if (internalError || !data || "error" in data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_error__WEBPACK_IMPORTED_MODULE_3__/* .ErrorScene */ ._, {
            code: 500
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_scene_byko_page__WEBPACK_IMPORTED_MODULE_2__/* .BykoPage */ .Z, {
        page: data
    }, slug);
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_byko_lib_api_dato_client__WEBPACK_IMPORTED_MODULE_1__/* .withDatoPageBySlug */ .RO)(Slug));


/***/ }),

/***/ 4651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ ErrorScene; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var component_page_container_src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/index.ts + 16 modules
var lib_illustrations_src = __webpack_require__(94845);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-error-virtual-40b506cce5/1/packages/scene-error/src/orange-arrow.tsx


const OrangeArrow = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "42",
        viewBox: "0 0 197 42",
        width: "197",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_d_892_203855)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5 21H175",
                        stroke: "#F85E00",
                        strokeLinecap: "round",
                        strokeWidth: "10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M169 5L185 21L169 37",
                        stroke: "#F85E00",
                        strokeLinecap: "round",
                        strokeWidth: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    height: "42",
                    id: "filter0_d_892_203855",
                    width: "196.071",
                    x: "0",
                    y: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            result: "hardAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dx: "4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 1 0 0 0 0 0.835294 0 0 0 0 0 0 0 0 1 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in2: "BackgroundImageFix",
                            mode: "normal",
                            result: "effect1_dropShadow_892_203855"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_892_203855",
                            mode: "normal",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-error-virtual-40b506cce5/1/packages/scene-error/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  justify-content: center;\n  margin-top: 64px;\n  gap: 64px;\n  @media screen and (max-width: ",
        "px) {\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  from {\n    transform: skew(0.5deg);\n  }\n  to {\n    transform: skew(-0.1deg);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  from {\n    fill: #00416A;\n  }\n  to {\n    fill: #8FDBC7;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 492px;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n  svg {\n    .backdrop-illus {\n      animation-direction: alternate;\n      animation-duration: 6s;\n      animation-iteration-count: infinite;\n      animation-name: ",
        ";\n      transform-origin: center top;\n    }\n    .leaf {\n      animation-direction: alternate;\n      animation-duration: 3s;\n      animation-iteration-count: infinite;\n      animation-name: ",
        ";\n      transform-origin: center top;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  h2 {\n    color: ",
        ";\n    font-size: 100px;\n    font-style: normal;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 120%;\n    text-shadow: 4px 0px 0px ",
        ";\n    @media screen and (max-width: ",
        "px) {\n      font-size: 30px;\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 494px;\n  height: 405px;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  &:before {\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 50%;\n    width: 403px;\n    height: 403px;\n    border-radius: 50%;\n    background-color: ",
        ';\n    content: "";\n    transform: translateX(-50%);\n    @media screen and (max-width: ',
        "px) {\n      width: 193px;\n      height: 193px;\n    }\n  }\n  h1 {\n    height: 280px;\n    align-items: center;\n    color: ",
        ";\n    font-size: 300px;\n    font-style: normal;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    text-shadow: 20px 0px 0px ",
        ";\n    @media screen and (max-width: ",
        "px) {\n      font-size: 130px;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 240px;\n    height: 196px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 48px;\n  row-gap: 24px;\n  p {\n    max-width: 432px;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const flow = (0,styled_components_browser_cjs.keyframes)(_templateObject1());
const pulse = (0,styled_components_browser_cjs.keyframes)(_templateObject2());
const ContentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-1"
})(_templateObject3());
const IllustrationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-2"
})(_templateObject4(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, pulse, flow);
const ArrowContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-3"
})(_templateObject5(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const HeaderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-4"
})(_templateObject6(), lib_styles_src/* theme.palette.blue.lightest */.rS.palette.blue.lightest, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const DescriptionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c0027d1-5"
})(_templateObject7());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-error-virtual-40b506cce5/1/packages/scene-error/src/scene-error.tsx











const ErrorScene = (param)=>{
    let { code  } = param;
    const Illustration = (0,react.useMemo)(()=>{
        if (code >= 500) {
            return lib_illustrations_src/* Error500 */.Vm;
        } else {
            return lib_illustrations_src/* Error400 */.LQ;
        }
    }, [
        code
    ]);
    const Parent = (0,react.useMemo)(()=>{
        // 404 error - ok to use NextJS to link
        if (code === 404) {
            return (param)=>/*#__PURE__*/ {
                let { children  } = param;
                return (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    legacyBehavior: true,
                    children: children
                });
            };
        }
        return (param)=>/*#__PURE__*/ {
            let { children  } = param;
            return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        };
    }, [
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H2, {
                                    children: code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrangeArrow, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H3, {
                                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                            children: "Villa"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    children: "\xdaps \xfeessi s\xed\xf0a vir\xf0ist ekki vera til, e\xf0a er ekki tilb\xfain. Vi\xf0 h\xf6ldum \xe1fram a\xf0 byggja hana en smellt \xfe\xfa \xfe\xe9r aftur \xe1 fors\xed\xf0una."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Parent, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                                        as: "href",
                                        buttonColor: "blueButton",
                                        href: "/",
                                        icon: lib_icons_src.LongArrowRightIcons,
                                        label: "Fors\xed\xf0a"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        size: "100%"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-error-virtual-40b506cce5/1/packages/scene-error/src/index.ts



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8344,7780,5776,9774,2888,179], function() { return __webpack_exec__(37948); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);